import $axios from 'axios'

export function getFilePath(params) {
        return $axios.post('/hewaCoreOrder/candidateInfo/reportPath', params)
}
